import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';

import { Pulldown } from 'jbc-front/components/icons';
import { openNewTab } from 'src/utils/Http';
import PayrollFBDataModalContainer from '../containers/PayrollFBDataModalContainer';
import styles from './ActionSection.scss';
import { withTranslation } from 'react-i18next';

const EmployeePaysMethod = onClickOutside(
  class extends Component {
    handleClickOutside = () => {
      this.props.hide();
    };

    constructor(props) {
      super(props);

      this.state = {
        isPayrollModalOpen: false
      };

      this.openPayrollModal = this.openPayrollModal.bind(this);
      this.closePayrollModal = this.closePayrollModal.bind(this);
    }

    openPayrollModal() {
      if (this.state.isPayrollModalOpen) return;
      this.setState({ ...this.state, isPayrollModalOpen: true });
    }

    closePayrollModal() {
      if (!this.state.isPayrollModalOpen) return;
      this.setState({ ...this.state, isPayrollModalOpen: false });
    }

    render() {
      const { showPayFbDataUrl, isConfirmed, isOpen, t } = this.props;

      return (
        <React.Fragment>
          <div className={isOpen ? styles.baloonWrap : styles.hide}>
            <div className={styles.baloonSecond}>
              <ul className={styles.links}>
                {/* @TODO: FirmBanking Export UI temporarily hidden - feature not yet developed */}
                {/* https://donuts-vn.atlassian.net/browse/JBC-121 */}
                <li>
                  <a
                    onClick={() => this.openPayrollModal()}
                    className={isConfirmed ? undefined : styles.disabled}
                    role="presentation"
                  >
                    <Pulldown size={8} />{t('features.EmployeePays.components.EmployeePaysMethod.Salary_transfer_data_export')}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => openNewTab(showPayFbDataUrl)}
                    className={isConfirmed ? undefined : styles.disabled}
                    role="presentation"
                  >
                    <Pulldown size={8} />{t('features.EmployeePays.components.EmployeePaysMethod.Salary_transfer_list')}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <PayrollFBDataModalContainer isOpen={this.state.isPayrollModalOpen} hideModal={this.closePayrollModal} />
        </React.Fragment>
      );
    }
  }
);

export default withTranslation()(EmployeePaysMethod);
